import { render, staticRenderFns } from "./DigitalID.vue?vue&type=template&id=309cbeb6&scoped=true"
import script from "./DigitalID.vue?vue&type=script&lang=js"
export * from "./DigitalID.vue?vue&type=script&lang=js"
import style0 from "./DigitalID.vue?vue&type=style&index=0&id=309cbeb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309cbeb6",
  null
  
)

export default component.exports